export default __webpack_public_path__ + "static/media/553.cbadc852.png";